import SolicitudCard from "./solicitudCard"
import './money.css'

const Money = ({ dataNequi, dataUsers, socket}) => {
    return (
        <div className="Money">
            <div className="solicitudes">
                {dataNequi.map((data,index) => {
                    const user = dataUsers.find(obj => obj.id === data.uid);
                    return <SolicitudCard key={index}dataNequi={data} dataUser={user} socket={socket}/>;  // Pasas directamente 'user'
                })}
            </div>
        </div>
    );
}
export default Money;
